const portfolioData = [
  {
    id: 1,
    title: "ERP系統客製化",
    category: "企業管理",
    image: require("../assets/images/erp-8012424_1280.jpg"),
    description: "為工業客戶開發的智慧物聯網監控平台，整合感測器數據，提供即時監控與分析功能，協助客戶提升生產效率。",
    technologies: ["React", "Node.js", "MongoDB", "MQTT"],
    client: "台灣工業科技公司",
    date: "2023年5月"
  },
  {
    id: 2,
    title: "電子商務網站改版",
    category: "電子商務",
    image: require("../assets/images/e-commerce-3406613_1280.jpg"),
    description: "為知名服飾品牌重新設計和開發電子商務平台，提升用戶體驗和轉換率，導入個人化推薦系統，整合多種支付方式。",
    technologies: ["React", "Redux", "Express.js", "PostgreSQL"],
    client: "時尚服飾品牌",
    date: "2023年3月"
  },
  {
    id: 3,
    title: "企業形象網站",
    category: "形象網站",
    image: require("../assets/images/web-1738168_1280.jpg"),
    description: "為金融科技新創公司打造現代化企業形象網站，展現公司核心價值和服務內容，導入互動式設計提升用戶體驗。",
    technologies: ["React", "Bootstrap", "GSAP", "Firebase"],
    client: "金融科技新創公司",
    date: "2023年1月"
  },
  {
    id: 4,
    title: "行動應用程式",
    category: "手機應用",
    image: require("../assets/images/telephone-4115290_1280.jpg"),
    description: "開發跨平台行動應用程式，提供健康追蹤和飲食建議功能，整合智慧手錶和健身追蹤器數據，為用戶提供個人化健康分析。",
    technologies: ["React Native", "Redux", "Firebase", "Health Kit"],
    client: "健康科技公司",
    date: "2022年11月"
  },
  {
    id: 5,
    title: "數據視覺化儀表板",
    category: "網頁應用",
    image: require("../assets/images/office-2717014_1280.jpg"),
    description: "設計開發高效能數據視覺化儀表板，幫助企業分析和呈現複雜業務數據，提供即時監控和自定義報表功能。",
    technologies: ["React", "D3.js", "Node.js", "MySQL"],
    client: "數據分析公司",
    date: "2022年9月"
  },
  {
    id: 6,
    title: "教育學習平台",
    category: "網頁應用",
    image: require("../assets/images/books-1655783_1280.jpg"),
    description: "為教育機構開發線上學習平台，提供課程管理、學生互動和評量系統，支援直播教學和錄影課程，並整合學習進度追蹤功能。",
    technologies: ["React", "WebRTC", "Express.js", "MongoDB"],
    client: "教育科技公司",
    date: "2022年7月"
  }
];

export default portfolioData; 